module.exports = "\n<div >\n  <app-covers-uploader></app-covers-uploader>\n</div>\n\n<!-- <div class=\"full-width\">\n  <app-bisac-search></app-bisac-search>\n</div>\n\n\n-->\n<form ref='uploadForm'\n   id='uploadForm'\n   action='http://localhost:3031/utils/fullname-splitter'\n   method='post'>\n      <input type=\"file\" #fileInput>\n     <input type='button' (click)='addFile()' />\n </form> \n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin.component.html
// module id = ./src/app/components/admin/admin.component.html
// module chunks = main